import httpClient from "../../../shared/api/httpClient";

export const vinculosApi = {
  list: () => httpClient.get("/api/v1/vinculos").then((r) => r.data.dados ?? []),

  get: (id) => httpClient.get(`/api/v1/vinculos/${id}`).then((r) => r.data.dados),

  create: ({ nome, tipo, cnpj, valorPlantao, valorFimDeSemana = null, horasPlantao, diaPagamento, diaLimiteNF, horaInicioPadrao = "", cor = "", endereco = "" }) =>
    httpClient
      .post("/api/v1/vinculos", {
        nome,
        tipo,
        cnpj,
        valor_plantao: valorPlantao,
        valor_fim_de_semana: valorFimDeSemana,
        horas_plantao: horasPlantao,
        dia_pagamento: diaPagamento,
        dia_limite_nf: diaLimiteNF,
        hora_inicio_padrao: horaInicioPadrao,
        cor,
        endereco,
      })
      .then((r) => r.data.dados),

  // valorFimDeSemana null (ou ausente) remove o valor de fim de semana do vínculo.
  update: (id, { nome, tipo, cnpj, valorPlantao, valorFimDeSemana = null, horasPlantao, diaPagamento, diaLimiteNF, horaInicioPadrao = "", cor = "", endereco = "" }) =>
    httpClient
      .put(`/api/v1/vinculos/${id}`, {
        nome,
        tipo,
        cnpj,
        valor_plantao: valorPlantao,
        valor_fim_de_semana: valorFimDeSemana,
        horas_plantao: horasPlantao,
        dia_pagamento: diaPagamento,
        dia_limite_nf: diaLimiteNF,
        hora_inicio_padrao: horaInicioPadrao,
        cor,
        endereco,
      })
      .then((r) => r.data.dados),

  setFavorito: (id, favorito) =>
    httpClient.patch(`/api/v1/vinculos/${id}/favorito`, { favorito }).then((r) => r.data.dados),

  remove: (id) => httpClient.delete(`/api/v1/vinculos/${id}`).then((r) => r.data.dados),
};

export const TIPOS_VINCULO = [
  { value: "privado", label: "Privado" },
  { value: "cooperativa", label: "Cooperativa" },
  { value: "organizacao_social", label: "Org. Social" },
  { value: "prefeitura_os", label: "Prefeitura / OS" },
];

export function rotuloTipoVinculo(tipo) {
  return TIPOS_VINCULO.find((t) => t.value === tipo)?.label ?? tipo;
}
